import React, { FunctionComponent } from 'react';
import { Box, Link } from '@hover/blueprint';
import { Link as GatsbyLink } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import {
  HOVER_ANDROID_DOWNLOAD_LINK,
  HOVER_APPLE_DOWNLOAD_LINK,
} from '../../../constants';
import { AppleStoreLogo, HoverLogoWhite } from '../../../icons';
import { FooterProps } from './types';

export type FooterContactProps = FooterProps['contact'];

export const FooterContact: FunctionComponent<FooterContactProps> = ({
  email,
  phone,
}) => (
  <>
    <Link as={GatsbyLink} to={`${process.env.GATSBY_V2_PREFIX}/`}>
      <HoverLogoWhite />
    </Link>
    <Box
      pt={{ base: 800, tablet: '56px' }}
      pb={{ base: 700, tablet: '56px' }}
      flexDirection="column"
    >
      <Link color="neutral.0" isMinimal href={`tel:${phone}`} mb={400}>
        {phone}
      </Link>
      <Link color="neutral.0" isMinimal href={`mailto:${email}`}>
        {email}
      </Link>
    </Box>
    <Box flexDirection={{ tablet: 'column', base: 'row' }} pb={500}>
      <Box pb={{ base: 0, tablet: 400 }} pr={{ base: 400, tablet: 0 }}>
        <Link as={GatsbyLink} to={HOVER_APPLE_DOWNLOAD_LINK}>
          <AppleStoreLogo />
        </Link>
      </Box>
      <Box>
        <Link as={GatsbyLink} to={HOVER_ANDROID_DOWNLOAD_LINK}>
          <Box maxW="115px" maxH="36px">
            <StaticImage
              src="../../../assets/images/google_play_logo.png"
              alt="google play"
              objectFit="contain"
            />
          </Box>
        </Link>
      </Box>
    </Box>
  </>
);
